import type IAnalyticsConfig from '../IAnalyticsConfig'
import { loadGoogleAnalytics, loadGoogleTagManager, loadHotjar } from '@/composables/analytics-utils'
import Analytics from './Analytics'

export default class DashAnalytics extends Analytics {
  loadAnalytics(config: IAnalyticsConfig): void {
    // Google Tag Manager
    loadGoogleTagManager(window.injectedEnv.FRONTEND_GTM)

    // Google Analytics
    loadGoogleAnalytics(config)

    // Hotjar Tracking
    loadHotjar(window.injectedEnv.FRONTEND_HOTJAR)

    // Hotjar Tracking 2
    loadHotjar(window.injectedEnv.FRONTEND_HOTJAR_2)
  }
}
